// #############################

// ##############################
// // // ACTION
// #############################

const action = {
  general: {
    name: "Nom",
    code: "Code / clé",
    groups: "Périmètre",
    type: "Type d'action",
    category: "Catégorie",
    subcategory: "Sous-catégorie",
    description: "Description - Objectifs",
    criticity: "Niveau de criticité",
    status: "Statut de l'action",
    lastupdate: "Date de dernière mise à jour Statut",
    wantedstartdate: "Date de début prévue",
    wantedenddate: "Date de fin prévue",
    realstartdate: "Date de début réel",
    realenddate: "Date de fin réel",
    personincharge: "Responsable en charge",
    orgincharge: "Organisation en charge",
    actionplan: "Plan d'action associé",
    depandantactions: "Dépendence(s)",
    neededactions: "",
  },
  details: {
    definition: "Définir l'action",
    preconization: "Préconisation choisie",
    target: "Elément(s) ciblé(s)",
    description: "Description générale",
    advantages: "Avantages",
    disadvantages: "Inconvénients",
    implemenation: "Procédé de mise en œuvre",
    regulation: "Réglementation & normes",
    imagecode: "Insérer une image",
  },
  impact: {
    auditedelements: "Type d'éléments audités",
    walls: "Sélection des parois",
    observations: "Observations",
    comments: "Commentaires",
    recommendations: "Recommendations",
    expecteddeliverables: "Livrables attendus",
    targetedenergy: "Fluide ciblé",
    targetedusage: "Usage considéré",
    targetedconsumption: "Consommation considérée (MWh ou m3)",
    surface: "Surface",
    deperdition: "Part des déperditions",
    thermicalresistance: "Rth",
    unitcost: "Coût unitaire",
    thickness: "Epaisseur",
    savings: "Gain",
    savingspercent: "%Eco",
    savingsponderation: "Pondération",
    savingstype: "Type d'impact de l'action",
    savingscalculation: "Calcul du gain",
    deperditions: "Part de déperditions",
    engineeringstudyedelements: "Type d'éléments audités",
    energy: "Energie/Fluide",
  },
  impactTURPE: {
    key: "Clé/code",
    meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE)",
    status: "Statut",
    address: "Adresse",
    dso: "Distributeur associé",
    psmax: "PS",
    pshph: "PS HPH",
    pshpe: "PS HPE",
    pshch: "PS HCH",
    pshce: "PS HCE",
    pspte: "PS Pointe",
    pshp: "PS HP",
    pshc: "PS HC",
    psbase: "PS Base",
    acheminement: "Acheminement",
    segment: "Segment",
    monthlyconsumption: "Activation releve mensuelle",
    dailyconsumption: "Activation releve journalière",
    loadcurve: "Activation relève courbe de charge",
    contractualdata: "Activation relève données contractuelles",
    associatedcontractid: "Contrat fournisseur associé",
    associatedfiles: "Fichiers associés",
    comments: "Commentaires",
    description: "Description",
    authorization: "Autorisation associée",
    pmaxhce: "Pmax atteinte HCE",
    pmaxhch: "Pmax atteinte HCH",
    pmaxhph: "Pmax atteinte HPH",
    pmaxhpe: "Pmax atteinte HPE",
    pmaxpte: "Pmax atteinte Pointe",
    pmaxhc: "Pmax atteinte HC",
    pmaxhp: "Pmax atteinte HP",
    pmaxbase: "Pmax atteinte Base",
    pmax: "Pmax",
    dcost: "Dépassements",
    dataquality: "Qualité de la donnée",
    recfta: "FTA",
    recps: "PS",
    recpshce: "PS HCE",
    recpshch: "PS HCH",
    recpshpe: "PS HPE",
    recpshph: "PS HPH ",
    recpspte: "PS Pointe ",
    ecosous: "Economie modifications",
    ecodep: "Economie dépassements",
    econet: "Economies nettes",
    eahce: "Consommation HCE",
    eahch: "Consommation HCH",
    eahpe: "Consommation HPE",
    eahph: "Consommation HPH",
  },
  projections: {
    projectedfinalenergyproduction: "Production projetées (MWh)",
    projectedfinalenergysavings: "Economies EF projetées (MWh)",
    projectedprimaryenergysavings: "Economies EP projetées (MWh)",
    projectedwatersavings: "Economies eau projetées (m3)",
    projectedco2savings: "Economies CO2 projetées ",
    projectedsavings: "Economies € TTC projetées",
    investment: "Investissement de départ (€)",
    ceeeligibility: "Eligibilité CEE",
    ceecumac: "CEE kWhcumac",
    ceeeuros: "CEE €",
    projectedroi: "TRI projeté (mois)",
    totalsavingsmwh :"Total economies projetées (MWh)",
    totalsavingsm3 :"Total economies projetées (m3)",
    totalsavingseuro :"Total economies projetées (€)",
    totalsavingsco2 :"Total economies projetées (kg eq. CO2)",
    totalproduction :"Total production projetée (MWh)",
  },
  progress: {
    progresslevel: "Niveau d'état d'avancement",
    comments: "Commentaires",
    toupdate: "A actualiser",
  },
  results: {
    validationdate: "Date de Validation",
    validatedby: "Validée par",
    realsavings: "Economies € TTC réelles",
    savingspercentage: "%Eco effectif sur la consommation considérée",
    realfinalenergyproduction: "Production réelles (kWh)",
    realfinalenergysavings: "Economies EF réelles (kWh)",
    realprimaryenergysavings: "Economies EP réelles (kWh)",
    realwatersavings: "Economies eau réelles (m3)",
    realco2savings: "Economies CO2 réelles",
    cost: "Investissement (€)",
    ceeeligibility: "Eligibilité CEE",
    ceecumac: "CEE kWhcumac",
    ceeeuros: "CEE €",
    realroi: "TRI réel (mois)",
    duration: "Durée de l'action (jours)",
    comments: "REX - Commentaires",
    totalsavingsmwh :"Total economies (MWh)",
    totalsavingsm3 :"Total economies (m3)",
    totalsavingseuro :"Total economies (€)",
    totalsavingsco2 :"Total economies (kg eq. CO2)",
    totalproduction :"Total production (MWh)",
  },
  comments: {
    comments: "Commentaires",
    associatedfile: "Fichiers associés",
    picture: "Photo",
  },
};

export { action };
